import React, { useState, useEffect } from 'react';
import { Button, Col, Row, ModalBody, Form, Spinner } from 'reactstrap';

import * as Yup from 'yup';
import { useFormik } from 'formik';

import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { addNewMeasurementFrequency, checkMeasurementFrequencyExists, updateMeasurementFrequency } from '../../../../../slices/measurementFrequency/thunk';
import { setRequireCloseModal } from '../../../../../slices/measurementFrequency/reducer';
import OInput from '../../../../../Components/OElements/OInput';

const MeasurementFrequencyForm = ({
	dataMeasurementFrequency,
	isEdit,
	handleToggleModal,
	isOpen,
	activeTab,
	toggleTab,
	toggleRefetch,
}) => {
	const dispatch = useDispatch();
	const [isLoading, setIsLoading] = useState(false);

	const selectorMeasurementFrequency = createSelector(
		state => state.MeasurementFrequency,
		data => ({
			isAdding: data.isAdding,
			isAdded: data.isAdded,
			isUpdating: data.isUpdating,
			isUpdated: data.isUpdated,
			isLoadingList: data.isLoadingList,
			requireCloseModal: data.requireCloseModal,
		})
	);

	const {
		isAdding,
		isAdded,
		isUpdating,
		isUpdated,
		isLoadingList,
		requireCloseModal,
	} = useSelector(selectorMeasurementFrequency);

	const validation = useFormik({
		enableReinitialize: true,
		initialValues: {
			name: dataMeasurementFrequency?.name || '',
			disable: dataMeasurementFrequency?.disable || false,
		},
		validationSchema: Yup.object({
			name: Yup.string()
				.required('Campo requerido')
				.test('name-exists-check', 'Frecuencia de Medición ya existe', async function (value) {
					if (value && (!isEdit || value !== dataMeasurementFrequency?.name)) {
						const result = await dispatch(checkMeasurementFrequencyExists(value));
						if (result.payload.exists) {
							return this.createError({ message: 'Frecuencia de Medición ya existe' });
						}
					}
					return true;
				}),
		}),
		validateOnChange: false,
		validateOnBlur: true,
		onSubmit: async values => {
			setIsLoading(true);
			const measurementFrequencyData = {
				...values,
				...(isEdit && { _id: dataMeasurementFrequency._id }),
			};

			if (isEdit) {
				await dispatch(updateMeasurementFrequency(measurementFrequencyData));
			} else {
				await dispatch(addNewMeasurementFrequency(measurementFrequencyData));
			}
			setIsLoading(false);
		},
	});

	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handleToggleModal();
				if (toggleRefetch) {
					setTimeout(() => {
						toggleRefetch();
					}, 100);
				}
			}
		}
	}, [requireCloseModal]);

	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (validation.isValid) setIsLoading(true);
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<Row className='g-3'>
					<Col lg={12}>
						<OInput
							name='name'
							label='Nombre de la Frecuencia de Medición'
							type='text'
							validation={validation}
							isRequired={true}
							classNameLabel='form-label'
							classNameInput='form-control'
						/>
					</Col>
				</Row>
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 justify-content-end'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}}
						className='btn-danger btn-label'
					>
						<i className='icon-x label-icon'></i>
						Cancelar
					</Button>
					<button
						type='submit'
						className='btn btn-label btn-primary'
						id='add-btn'
						disabled={isLoading || isAdding || isUpdating}
					>
						{isLoading || isAdding || isUpdating ? (
							<i className='label-icon'><Spinner size='sm' /></i>
						) : (
							<i className='ri-save-3-line label-icon'></i>
						)}
						{isEdit ? 'Editar' : 'Crear'} Frecuencia de Medición
					</button>
				</div>
			</div>
		</Form>
	);
};

export default MeasurementFrequencyForm;
